import { render, staticRenderFns } from "./WaitingTime.vue?vue&type=template&id=ddad5850&scoped=true"
import script from "./WaitingTime.vue?vue&type=script&lang=ts"
export * from "./WaitingTime.vue?vue&type=script&lang=ts"
import style0 from "./WaitingTime.vue?vue&type=style&index=0&id=ddad5850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddad5850",
  null
  
)

export default component.exports